import { z } from 'zod'

/**
 * 운영자 이미지 업로드 (BIZ-111 후속). 배너·콘텐츠 등 관리자 이미지의 공용 업로드 경로.
 *
 * 업로드하면 이미지 파이프라인으로 리사이즈·정규화한 뒤 비공개 S3에 저장하고,
 * 저장 키(key)와 미리보기용 서명 URL(url)을 돌려준다. 저장은 **키**만 참조하고,
 * 노출 시점에 서명 URL을 새로 발급한다 — 원본 오브젝트 URL은 밖으로 내보내지 않는다.
 */
export const assetUploadResponse = z.object({
  /** 저장소 키. 배너 등 도메인 레코드가 이 값을 보관한다. */
  key: z.string(),
  /** 미리보기용 서명 URL(만료됨). 표시에만 쓰고 저장하지 않는다. */
  url: z.string(),
})
export type AssetUploadResponse = z.infer<typeof assetUploadResponse>
